module.exports = __webpack_public_path__ + "static/media/nysdec_logo.1995fa73.png";